import { PageHero, Eyebrow, Icon } from "@/components/site/ui";
import { Reveal, Stagger, StaggerItem, Counter } from "@/components/site/motion";
import { APPROACH_STEPS, CONTINENT_STATS, REASONS } from "@/data/content";

export default function Approche() {
  return (
    <>
      <PageHero
        eyebrow="Notre méthodologie"
        titleLines={["Une méthode,", "des résultats concrets"]}
        subtitle="Un processus éprouvé en cinq étapes, pensé pour transformer votre ambition en réussite mesurable."
      />

      <section className="bg-cream py-24 sm:py-32" data-testid="approach-timeline">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal className="max-w-2xl">
            <Eyebrow>Comment ça marche</Eyebrow>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl font-medium text-navy">Cinq étapes, <em className="not-italic italic text-gold-gradient">un partenariat</em></h2>
          </Reveal>
          <Stagger className="mt-16 grid gap-8 md:grid-cols-3 lg:grid-cols-5 relative">
            {APPROACH_STEPS.map((s) => (
              <StaggerItem key={s.num}>
                <div className="relative">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy text-gold">
                      <Icon name={s.icon} size={22} />
                    </span>
                    <span className="font-display text-4xl font-bold text-navy/10">{s.num}</span>
                  </div>
                  <h3 className="font-display text-lg text-navy leading-snug">{s.title}</h3>
                  <p className="mt-2 text-sm text-anthracite font-body">{s.desc}</p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="bg-night py-24" data-testid="approach-continent">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal className="max-w-2xl">
            <Eyebrow light>Opportunités</Eyebrow>
            <h2 className="mt-5 font-display text-3xl sm:text-4xl font-medium text-white">L'Afrique, territoire d'<em className="not-italic italic text-gold-gradient">opportunités</em></h2>
          </Reveal>
          <Stagger className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-8">
            {CONTINENT_STATS.map((s) => (
              <StaggerItem key={s.label} className="text-center lg:text-left">
                <div className="font-display text-4xl sm:text-5xl font-semibold text-gold-gradient">
                  <Counter value={parseFloat(s.value.replace(",", "."))} decimals={s.value.includes(",") ? 1 : 0} suffix={s.suffix} />
                </div>
                <p className="mt-2 text-sm text-white/70 font-body">{s.label}</p>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="bg-cream py-24 sm:py-32" data-testid="approach-reasons">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal className="max-w-2xl">
            <Eyebrow>Pourquoi nous</Eyebrow>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl font-medium text-navy">Huit raisons de nous faire <em className="not-italic italic text-gold-gradient">confiance</em></h2>
          </Reveal>
          <Stagger className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            {REASONS.map((r) => (
              <StaggerItem key={r.title}>
                <div className="card-lumen rounded-2xl border border-navy/10 bg-white p-8 h-full hover:border-gold">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-navy text-gold">
                    <Icon name={r.icon} size={22} />
                  </span>
                  <h3 className="mt-5 font-display text-xl text-navy">{r.title}</h3>
                  <p className="mt-2 text-sm text-anthracite font-body leading-relaxed">{r.desc}</p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </>
  );
}
